module.exports = "//cdn.mxpnl.com/static/asset-cache/fdee579d6af90714c50a671cb2c62e23/iron/common/widgets/intro/images/onboarding-dashboard.svg";